import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

// index.html carries fallback meta tags for crawlers that don't run JavaScript. Each page
// renders its own via SEOHead, so drop the fallbacks first to avoid duplicate tags.
document.querySelectorAll('head [data-static-seo]').forEach(node => node.remove());

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <HelmetProvider>
    <BrowserRouter>
      <App />
    </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);

reportWebVitals();